import Swiper from "swiper/bundle";
import { Pagination } from "swiper/modules";
import "swiper/css/bundle";
import "swiper/css/pagination";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class PointSlide {
    constructor() {
        this._init();
    }

    _init() {
        this.setSwiper();
    }

    setSwiper() {
        [...document.querySelectorAll(".swiper")].forEach((slide) => {
            const opts = {
                centeredSlides: true,
                modules: [Pagination],
                spaceBetween: -13,
                slidesPerView: "auto",
                speed: 700,
                grabCursor: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    706: {
                        spaceBetween: 80,
                    },
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            };
            this.swiper = new Swiper(slide, opts);
        });

        this.scrollArwMotion();
        // this.scrollMoveSwiper();
    }

    scrollArwMotion() {
        const btns = document.querySelectorAll(".swiper-button");
        const swiper = document.querySelector(".js-swiper");
        btns.forEach((btn) => {
            btn.addEventListener("click", () => {
                swiper.classList.add("-move");
                setTimeout(() => {
                    swiper.classList.remove("-move");
                }, 500);
            });
        });
    }

    scrollMoveSwiper() {
        const slidesWrapper = document.querySelector(".swiper-wrapper");
        const slides = gsap.utils.toArray(".js-scroll");
        const slidesWidth = slidesWrapper.scrollWidth; // 合計スライド幅を取得
        const point = document.querySelector(".js-point");
        const header = document.querySelector(".js-menu");
        const headerHeight = header.clientHeight;

        gsap.to(slidesWrapper, {
            xPercent: 100 * (slides.length - 1),
            scrollTrigger: {
                trigger: point,
                start: `top top`,
                end: `+=${slidesWidth}`,
                scrub: true,
                pin: true,
                pinSpacing: false,
                markers: true,
            },
        });
    }
}
